<div class="grid grid-cols-[3rem_5rem_1fr] pt-2">
    <ng-container
        [ngTemplateOutlet]="
            env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY || env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE
                ? scheduleStartTime
                : startTime
        ">
    </ng-container>
    <div class="flex items-center justify-center">
        <div
            class="relative flex h-full w-1.5 items-center justify-center"
            [ngStyle]="getOriginPath(leg?.icon?.color || leg?.routeColor)">
            <div
                class="var-app-light:bg-white absolute top-3 h-2.5 w-2.5 rounded-full border-[3px] border-solid border-secondary bg-secondary dark:border-contrast-yellow dark:bg-contrast-black"
                [ngStyle]="{
                    'border-color':
                        (isContrast$ | async) ? null : otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor),
                    'background-color':
                        env.JOURNEY_PLANNER?.SHOW_EMPTY_LEG_POINT_CIRCLE || (isContrast$ | async)
                            ? null
                            : otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor)
                }"></div>
        </div>
    </div>

    <div class="min-w-0 break-words pb-0.5 pt-1.5">
        <p class="flex items-center text-base leading-5">
            <span
                class="min-w-0 flex-1"
                [ngClass]="{
                    'text-danger line-through': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
                }">
                {{ leg?.from?.name }}
            </span>
            <span
                class="ml-1 flex h-4 w-4 items-center justify-center rounded-[3px] border border-solid border-grey-dark text-xs font-semibold text-grey-dark dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngIf="!env.JOURNEY_PLANNER?.SHOW_PLATFORM_PREFIX">
                {{ leg?.from?.platformCode }}
            </span>
            <span
                class="text-md ml-1 flex h-4 items-center justify-center text-grey-dark dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngIf="leg?.from?.platformCode && env.JOURNEY_PLANNER?.SHOW_PLATFORM_PREFIX">
                {{ 'JOURNEY_PLANNER_PLATFORM_PREFIX' | translate }} {{ leg?.from?.platformCode }}
            </span>
        </p>
        <rwidget-disruption-message
            *ngFor="let message of messagesForCorrespondingStopByFrom"
            [disruptionMessage]="message"
            [commonExtraClasses]="'mt-0.5 block px-1 [&:not(:first-child)]:mt-1'"
            [commonExtraSpanClasses]="'block text-xxs font-semibold leading-4'"></rwidget-disruption-message>
        <p
            class="text-xs font-medium text-[#838383] dark:text-contrast-yellow"
            [ngClass]="{ 'mt-3': getMessageForCorrespondingStop(leg?.from)?.length === 0 }">
            {{ 'ITINERARY_INSTRUCTIONS_TAKE_ROUTE' | translate }} {{ leg?.routeShortName }}

            <span
                *ngIf="
                    leg?.routeShortName &&
                    (leg.price || (env.JOURNEY_PLANNER?.SHOW_FARE_URL_ITINERARY_INSTRUCTIONS && routeUrl))
                ">
            </span>

            <ng-container *ngIf="leg.price">
                &nbsp;&#8226;&nbsp;
                {{ leg.price | moneyFormat }}<span *ngIf="leg.currency">{{ leg.currency }}</span>
            </ng-container>

            <ng-container *ngIf="!leg.price && env.JOURNEY_PLANNER?.SHOW_FARE_URL_ITINERARY_INSTRUCTIONS && routeUrl">
                <span> &nbsp;&#8226;&nbsp; </span>

                <a class="text-primary" [href]="routeUrl" (click)="$event.stopPropagation()" target="_blank">
                    {{ 'ITINERARY_INSTRUCTIONS_TICKET_INFO' | translate }} →
                </a>
            </ng-container>
        </p>
    </div>
</div>

<div class="grid grid-cols-[3rem_5rem_1fr]">
    <div class="flex items-start">
        <ng-container [ngSwitch]="leg?.mode">
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchCase="'TRAM'"
                [src]="(assetsPath$ | async) + '/img/journey-planner/tram.svg'"
                alt="Tram icon" />
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchCase="'WALK'"
                [src]="(assetsPath$ | async) + '/img/journey-planner/walk.svg'"
                alt="Walk icon" />
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchCase="'RAIL'"
                [src]="(assetsPath$ | async) + '/img/journey-planner/train.svg'"
                alt="Rail icon" />
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchCase="'FERRY'"
                [src]="(assetsPath$ | async) + '/img/journey-planner/ferry.svg'"
                alt="Ferry icon" />
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchCase="'TROLLEY'"
                [src]="(assetsPath$ | async) + '/img/journey-planner/trolley.svg'"
                alt="Trolley icon" />
            <img
                class="mt-4 dark:filter-yellow"
                *ngSwitchDefault
                [src]="(assetsPath$ | async) + '/img/journey-planner/bus.svg'"
                aria-hidden="true"
                alt="Bus icon" />
        </ng-container>
    </div>
    <div class="flex items-center justify-center">
        <div class="flex h-full w-1.5 justify-center" [ngStyle]="getFullPath(leg?.icon?.color || leg?.routeColor)">
            <rwidget-route-short-name
                class="mt-3"
                [label]="leg?.routeShortName"
                [shape]="leg?.icon?.shape || ShapeType.ROUNDED"
                [color]="otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor)"
                [textColor]="
                    otpUtil.resolveColor(leg?.icon?.textColor || leg.routeTextColor, 'white')
                "></rwidget-route-short-name>
        </div>
    </div>
    <div class="items-star flex flex-col">
        <div class="flex flex-row items-center">
            <div class="flex-grow">
                <p
                    class="text-base"
                    [ngClass]="{
                        'text-[#D04D43] line-through': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
                    }">
                    {{ leg?.headsign ?? leg?.routeLongName }}
                </p>
            </div>
            <div class="ml-2 flex">
                <img
                    class="max-w-12 max-h-12 object-contain"
                    *ngIf="leg?.operatorCode"
                    [src]="operatorLogosBaseUrl + leg?.operatorCode + '.svg'"
                    [hidden]="!operatorLogoFileExists"
                    (error)="operatorLogoFileExists = false"
                    title="{{ leg?.operatorName }}"
                    alt="{{ leg?.operatorCode }} {{ leg?.operatorName }} logo" />
            </div>
        </div>

        <p class="flex gap-1" *ngIf="env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled">
            <ion-icon
                class="text-base"
                aria-label="{{ 'TRIP_TIME_CANCELLED_ARIA_LABEL' | translate }}"
                src="{{ assetsPath$ | async }}/img/alert-cancelled.svg"></ion-icon>
            <span class="text-[0.6875rem] text-danger">{{ 'TRIP_IS_CANCELLED_TEXT' | translate }}</span>
        </p>
        <rwidget-disruption-message
            *ngFor="let message of busDisruptionMessages"
            [disruptionMessage]="message"
            [commonExtraClasses]="'mb-1 flex w-full items-center p-1 dark:bg-contrast-yellow'"
            [commonExtraSpanClasses]="'flex-1 text-xxs font-semibold'"></rwidget-disruption-message>
        <p
            class="mb-2 flex w-fit items-center rounded-[3px] bg-secondary p-1 text-xs font-semibold text-white"
            *ngFor="let message of footnotes">
            <ion-icon
                class="mr-1"
                title="{{ 'INFO' | translate }}"
                src="{{ assetsPath$ | async }}/img/explore/icon-info.svg"></ion-icon>
            {{ message?.headerTextDefault }}
        </p>
        <ng-container *ngIf="this.env.JOURNEY_PLANNER?.IS_PUBTRANS_MESSAGE">
            <rwidget-disruption-message
                *ngFor="let message of messagesForCorrespondingRoute"
                [disruptionMessage]="message"
                [commonExtraClasses]="'mb-1 block p-1'"
                [commonExtraSpanClasses]="'text-xxs font-semibold'"></rwidget-disruption-message>
        </ng-container>

        <p
            class="text-xs font-medium"
            *ngIf="leg?.intermediateStops?.length > 0"
            [class]="busDisruptionMessages?.length > 0 ? 'mt-1' : ''">
            <span
                class="text-old_silver mr-3 inline-flex align-middle dark:text-contrast-yellow"
                *ngIf="!accordionGroup.value">
                {{ leg.intermediateStops?.length }}
                {{ 'ITINERARY_INSTRUCTIONS_NR_OF_STOPS' | translate | lowercase }}
            </span>
            <button
                class="orb-app-light:text-secondary orb-app-light-dark:text-xs gl-light:text-[var(--color-secondary)] inline-flex cursor-pointer items-center p-0 align-middle text-xxs font-medium text-primary dark:text-contrast-yellow"
                [attr.aria-expanded]="isStopsExpanded"
                (click)="toggleExpandCollapseTripStops()">
                <ion-icon
                    class="text-[1rem] text-secondary dark:filter-yellow"
                    *ngIf="env.JOURNEY_PLANNER?.SHOW_ICON_FOR_ITINERARY_INSTRUCTIONS_STOP_TOGGLE"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow-down-circle.svg"></ion-icon>
                <span>
                    {{
                        (accordionGroup.value
                            ? 'ITINERARY_INSTRUCTIONS_HIDE_STOPS'
                            : 'ITINERARY_INSTRUCTIONS_SHOW_STOPS'
                        ) | translate
                    }}
                </span>
            </button>
        </p>
    </div>
</div>

<div
    class="var-app-light:bg-primary var-app-light:text-white vl-app-light:bg-primary drt-message flex-align-center margin-right-4 flex gap-5 rounded-[3px] px-2 py-6 dark:border-2 dark:border-solid dark:border-contrast-yellow"
    *ngIf="leg.mode === legMode.Flexible">
    <ion-icon
        class="h-8 w-8"
        [src]="(assetsPath$ | async) + '/img/journey-planner/drt-bus.svg'"
        alt="DRT bus icon"></ion-icon>
    <p class="flex-1 text-base text-white">
        <span innerHtml="{{ 'JOURNEY_PLANNER_DRT_BUS_MESSAGE' | translate }}"></span>
    </p>
</div>

<ion-accordion-group #middleTripSteps>
    <ion-accordion value="journeyPlanLegStops">
        <div slot="content">
            <div class="grid grid-cols-[3rem_5rem_1fr]">
                <ng-container *ngFor="let stopTime of leg?.intermediateStops; let i = index">
                    <p
                        class="text-old_silver flex items-center text-base dark:text-contrast-yellow"
                        [ngClass]="{
                            'text-danger line-through': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
                        }">
                        {{ stopTime.departure | momentDate: 'HH:mm' : env.TIMEZONE }}
                    </p>
                    <div class="flex items-center justify-center">
                        <div
                            class="flex h-full w-1.5 items-center justify-center dark:filter-yellow"
                            [ngStyle]="getFullPath(leg?.icon?.color || leg?.routeColor)">
                            <div
                                class="absolute h-2.5 w-2.5 rounded-full border-[3px] border-solid bg-white dark:border-contrast-yellow dark:bg-contrast-black"
                                [ngStyle]="{
                                    'border-color': otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor),
                                    'background-color':
                                        env.APP_NAME === 'vastmanland-app'
                                            ? otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor)
                                            : 'white'
                                }"></div>
                        </div>
                    </div>
                    <div class="flex flex-col items-start pb-1.5 pt-1.5 text-base">
                        <p
                            class="flex items-center"
                            [ngClass]="{
                                'text-[#D04D43] line-through':
                                    env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
                            }">
                            {{ stopTime.name }}
                        </p>
                        <ng-container
                            *ngIf="
                                messagesForCorrespondingIntermediateStops[stopTime.stopId || stopTime.stopCode]
                                    ?.length > 0
                            ">
                            <rwidget-disruption-message
                                class="self-stretch"
                                *ngFor="
                                    let message of messagesForCorrespondingIntermediateStops[
                                        stopTime.stopId || stopTime.stopCode
                                    ]
                                "
                                [disruptionMessage]="message"
                                [commonExtraClasses]="'mb-2 flex items-center p-1 [&:not(:first-child)]:mt-1'"
                                [commonExtraSpanClasses]="
                                    'flex-1 text-xxs font-semibold leading-4'
                                "></rwidget-disruption-message>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </ion-accordion>
</ion-accordion-group>

<div class="grid grid-cols-[3rem_5rem_1fr] pb-2">
    <ng-container
        [ngTemplateOutlet]="
            env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY || env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE
                ? scheduleEndTime
                : endTime
        ">
    </ng-container>
    <div class="flex items-center justify-center">
        <div
            class="relative flex h-full w-1.5 items-center justify-center"
            [ngStyle]="getDestinationPath(leg?.icon?.color || leg?.routeColor)">
            <div
                class="var-app-light:bg-white absolute top-[calc(70%-0.3rem)] h-2.5 w-2.5 rounded-full border-[3px] border-solid border-secondary bg-secondary dark:border-contrast-yellow dark:bg-contrast-black"
                [ngStyle]="{
                    'border-color':
                        (isContrast$ | async) ? null : otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor),
                    'background-color':
                        env.JOURNEY_PLANNER?.SHOW_EMPTY_LEG_POINT_CIRCLE || (isContrast$ | async)
                            ? null
                            : otpUtil.resolveColor(leg?.icon?.color || leg?.routeColor)
                }"></div>
        </div>
    </div>

    <div
        class="flex min-w-0 flex-col break-words pb-0.5 pt-1.5"
        [ngClass]="{ 'mt-4': leg?.mode === legMode.Flexible && !accordionGroup.value }">
        <p class="mt-2 flex items-center text-base">
            <span
                class="min-w-0 flex-1"
                [ngClass]="{
                    'text-danger line-through': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
                }">
                {{ leg?.to?.name }}
            </span>
            <span
                class="ml-1 flex h-4 w-4 items-center justify-center rounded-[3px] border border-solid border-grey-dark text-xs font-semibold text-grey-dark dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngIf="leg?.to?.platformCode && !env.JOURNEY_PLANNER?.SHOW_PLATFORM_PREFIX">
                {{ leg?.to?.platformCode }}
            </span>
            <span
                class="text-md ml-1 flex h-4 items-center justify-center text-grey-dark dark:border-contrast-yellow dark:text-contrast-yellow"
                *ngIf="leg?.to?.platformCode && env.JOURNEY_PLANNER?.SHOW_PLATFORM_PREFIX">
                {{ 'JOURNEY_PLANNER_PLATFORM_PREFIX' | translate }} {{ leg?.to?.platformCode }}
            </span>
        </p>
        <ng-container *ngIf="leg && messagesForCorrespondingStopByTo?.length > 0">
            <rwidget-disruption-message
                *ngFor="let message of messagesForCorrespondingStopByTo"
                [disruptionMessage]="message"
                [commonExtraClasses]="'flex items-center px-1 [&:not(:first-child)]:mt-1'"
                [commonExtraSpanClasses]="'flex-1 text-xxs font-semibold leading-4'"></rwidget-disruption-message>
        </ng-container>
    </div>
</div>

<ng-template #scheduleStartTime>
    <div class="pb-0.5 pt-1.5" *ngIf="this.env.JOURNEY_PLANNER?.REALTIME_AVAILABLE">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayStartTime,
                isLarge: true,
                isItalic: isDepartureApproximateTime,
                isCancelled: false,
                hasTopPadding: true
            }"></ng-container>
        <ng-container
            *ngIf="crossedOutStartTime"
            [ngTemplateOutlet]="crossedOutTimeLabel"
            [ngTemplateOutletContext]="{
                time: crossedOutStartTime,
                isGrey: true
            }"></ng-container>
    </div>
</ng-template>

<ng-template #startTime>
    <div *ngIf="!this.env.JOURNEY_PLANNER?.REALTIME_AVAILABLE">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayStartTime,
                isItalic: isDepartureApproximateTime,
                isCancelled: env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
            }"></ng-container>
    </div>
    <div class="pb-0.5 pt-1.5" *ngIf="this.env.JOURNEY_PLANNER?.REALTIME_AVAILABLE">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayStartTime,
                isLarge: true,
                isItalic: isDepartureApproximateTime,
                isCancelled: env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled,
                hasTopPadding: true
            }"></ng-container>
        <ng-container
            *ngIf="crossedOutStartTime"
            [ngTemplateOutlet]="crossedOutTimeLabel"
            [ngTemplateOutletContext]="{
                time: crossedOutStartTime,
                isCancelled: env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled,
                hasVlOverrides: true
            }"></ng-container>
    </div>
</ng-template>

<ng-template #scheduleEndTime>
    <div class="vl-app-light-dark:pb-0 vl-app-light-dark:mt-2 flex flex-col items-start pb-1 pt-2.5">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayEndTime,
                isLarge: true,
                isItalic: IsArrivalApproximateTime,
                isCancelled: false,
                hasTopMargin: leg?.mode === legMode.Flexible && !accordionGroup.value
            }"></ng-container>
        <ng-container
            *ngIf="crossedOutEndTime"
            [ngTemplateOutlet]="crossedOutTimeLabel"
            [ngTemplateOutletContext]="{
                time: crossedOutEndTime
            }"></ng-container>
    </div>
</ng-template>

<ng-template #endTime>
    <div *ngIf="!this.env.JOURNEY_PLANNER?.REALTIME_AVAILABLE" [ngClass]="{ 'mt-4': leg?.mode === legMode.Flexible }">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayEndTime,
                isItalic: IsArrivalApproximateTime,
                isCancelled: env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled
            }"></ng-container>
    </div>
    <div
        class="vl-app-light-dark:pb-0 vl-app-light-dark:mt-2 flex flex-col items-start pb-1 pt-2.5"
        *ngIf="this.env.JOURNEY_PLANNER?.REALTIME_AVAILABLE">
        <ng-container
            [ngTemplateOutlet]="timeLabel"
            [ngTemplateOutletContext]="{
                time: displayEndTime,
                isLarge: true,
                isItalic: IsArrivalApproximateTime,
                isCancelled: env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && leg.canceled,
                hasTopMargin: leg?.mode === legMode.Flexible && !accordionGroup.value
            }"></ng-container>
        <ng-container
            *ngIf="crossedOutEndTime"
            [ngTemplateOutlet]="crossedOutTimeLabel"
            [ngTemplateOutletContext]="{
                time: crossedOutEndTime,
                hasVlOverrides: true
            }"></ng-container>
    </div>
</ng-template>

<ng-template
    #timeLabel
    let-time="time"
    let-isLarge="isLarge"
    let-isItalic="isItalic"
    let-isCancelled="isCancelled"
    let-hasTopPadding="hasTopPadding"
    let-hasTopMargin="hasTopMargin">
    <p
        class="flex items-center dark:text-contrast-yellow"
        [ngClass]="{
            'text-base leading-5': isLarge,
            'pt-2': hasTopPadding,
            'vl-app-light-dark:pt-1': hasTopPadding,
            'mt-4': hasTopMargin,
            'italic': isItalic,
            'text-[#D04D43] line-through': isCancelled,
            'text-[#414141]': !isCancelled
        }">
        {{ time | momentDate: 'HH:mm' : env.TIMEZONE }}
    </p>
</ng-template>

<ng-template
    #crossedOutTimeLabel
    let-time="time"
    let-isCancelled="isCancelled"
    let-isGrey="isGrey"
    let-hasVlOverrides="hasVlOverrides">
    <p
        class="ml-1 flex items-center text-sm line-through dark:text-contrast-yellow"
        [ngClass]="{
            'vl-app-light-dark:ml-0': hasVlOverrides,
            'text-[#D04D43]': isCancelled,
            'text-[#838383]': !isCancelled && isGrey,
            'text-[#414141]': !isCancelled && !isGrey
        }">
        {{ time | momentDate: 'HH:mm' : env.TIMEZONE }}
    </p>
</ng-template>
